export class FileData {
  contentType: string;
  base64: string;
  fileName: string;

  public constructor(init?: Partial<FileData>) {
    Object.assign(this, init);
  }
}
